module.exports = __webpack_public_path__ + "static/media/1020339.50f3edf4.png";